











































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Prices extends Vue {
  prices: any = window.prices;
}
